<template>
  <div id="box">
    <footer class="footer">
      <div class="footer-inner container">
        <div class="footer-top">
          <img src="/imgs/footer/images/images/footer-logo_06_03.png" alt="" />
          <div class="footer-top-title">微观流动,巨量未来</div>
        </div>
        <div class="footer-bottom">
          <div>
            <div class="footer-bottom-left">
              <div>
                <img src="/imgs/footer/images/erweima1_06.png" alt="二维码1" />
                <p>关注公众号,了解更多</p>
              </div>
              <div>
                <img src="/imgs/footer/images/erweima2_06.png" alt="二维码2" />
                <p>关注视频号,了解更多</p>
              </div>
            </div>
            <div class="footer-phone">
              <span>0532-66727975</span
              ><span
                ><img
                  src="/imgs/footer/images/images/dianhua_10_03.png"
                  alt=""
                />13210867858</span
              ><span
                ><img
                  src="/imgs/footer/images/images/dianhua_10_03.png"
                  alt=""
                />13210877008</span
              >
            </div>
          </div>

          <div class="footer-bottom-right">
            <dl class="footer-list">
              <div class="footer-col">
                <router-link to="/goin"><dt>走进弗鲁微</dt></router-link>
                <dd><router-link to="/goin#intro">公司介绍</router-link></dd>
                <dd><router-link to="/goin#culture">企业文化</router-link></dd>
                <dd><router-link to="/goin#honor">荣誉资质</router-link></dd>
                <dd><router-link to="/goin#employee">员工风采</router-link></dd>
              </div>
              <div class="footer-col">
                <router-link to="/products"><dt>匠心产品</dt></router-link>
                <dd><router-link to="/products?tab=dynamic">动态管式反应器系列</router-link></dd>
                <dd><router-link to="/products?tab=microchannel">微通道反应器系列</router-link></dd>
                <dd><router-link to="/products?tab=microbubble">微气泡反应器系列</router-link></dd>
                <dd><router-link to="/products?tab=mixer">微混合器系列</router-link></dd>
              </div>
              <div class="footer-col">
                <router-link to="/cases"><dt>研发案例</dt></router-link>
                <dd><router-link to="/cases#rd">研发案例</router-link></dd>
                <dd><router-link to="/cases#engineering">工程案例</router-link></dd>
              </div>
              <div class="footer-col">
                <router-link to="/technology"><dt>科技研发</dt></router-link>
                <dd><router-link to="/technology#rnd-team">研发团队</router-link></dd>
                <dd><router-link to="/technology#factory-show">工厂展示</router-link></dd>
                <dd><router-link to="/technology#employment-base">就业基地</router-link></dd>
              </div>
              <div class="footer-col">
                <router-link to="/news"><dt>新闻动态</dt></router-link>
                <dd><router-link to="/news?tab=company">公司新闻</router-link></dd>
                <dd><router-link to="/news?tab=industry">行业资讯</router-link></dd>
              </div>
              <div class="footer-col">
                <router-link to="/contact"><dt>联系我们</dt></router-link>
                <dd><router-link to="/contact#join-us">加入我们</router-link></dd>
                <dd><router-link to="/contact#contact-info">联系信息</router-link></dd>
                <dd><router-link to="/contact#online-message">在线留言</router-link></dd>
              </div>
            </dl>
          </div>
        </div>

        <div class="footer-copyright">
          <p>Copyright ©2025 山东弗鲁微科技有限公司 All Rights Reserved</p>
          <p>网站建设 | 东八区创意</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.footer {
  min-height: 550px;
  background-image: url(/public/imgs/footer/images/footer-bg_05.png);
  background-size: cover;
  background-position: center;
  margin-top:-3.5rem;
  /* border-top: 1px solid #e0e0e0; */
  /* padding: 24px 0; */
  font-size: 14px;
  /* color: #fff; */
  font-family: "HarmonyOS_Sans_SC_Light";
  color: #b2bdcd;
  border-radius: 75px 75px 0 0;
  position: relative;
  z-index: 3;
}

@media (max-width: 768px) {
  .footer {
    display: none;
    /* min-height: auto;
    border-radius: 40px 40px 0 0; */
  }
  
  .footer-inner {
    max-width: 95%;
    padding: 0 0.5rem 1rem;
  }
  
  .footer-top {
    flex-direction: column;
    text-align: center;
    padding: 2rem 1rem 1.5rem;
    gap: 1rem;
  }
  
  .footer-top-title {
    font-size: 1.8rem;
    letter-spacing: 0.1rem;
  }
  
  .footer-top img {
    height: 40px;
  }
  
  .footer-bottom {
    flex-direction: column;
    padding: 2rem 0;
    gap: 2rem;
  }
  
  .footer-bottom-left {
    justify-content: center;
    gap: 1.5rem;
  }
  
  .footer-bottom-left img {
    width: 100px;
    height: 100px;
  }
  
  .footer-bottom-left p {
    font-size: 0.9rem;
  }
  
  .footer-phone {
    flex-direction: column;
    align-items: center;
    gap: 0.8rem;
    font-size: 1.2rem;
  }
  
  .footer-phone span {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  
  .footer-list {
    justify-content: center;
    gap: 1.5rem;
  }
  
  .footer-col {
    min-width: 100px;
    text-align: center;
  }
  
  .footer-col dt {
    margin-bottom: 1rem;
    font-size: 1rem;
  }
  
  .footer-col dd {
    margin: 0.8rem 0;
    font-size: 0.9rem;
  }
  
  .footer-copyright {
    flex-direction: column;
    text-align: center;
    gap: 0.5rem;
    font-size: 0.9rem;
  }
}

.footer-inner {
  max-width: 90%;
  padding: 0 1rem 1rem;
}
.footer-top {
  width: 96%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2.5vw 1rem 2rem;
  border-bottom: 1px solid #e0e0e0;
  /* gap: 20px; */
}
.footer-top-title {
  color: #fff;
  font-size: 2.2rem;
  letter-spacing: 0.2rem;
  /* font-weight: bold; */
}
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4rem 0rem;
}

.footer-bottom-left {
  display: flex;
  gap: 2.5rem;
}
.footer-bottom-left > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
.footer-bottom-left img {
  width: 135px;
  height: 135px;
  object-fit: contain;
  border-radius: 8px;
  background: #fff;
}

.footer-list {
  display: flex;
  flex-wrap: wrap;
  gap: 2.6rem;
  margin: 0;
}
@media (max-width: 1700px) {
  .footer-list {
    flex-wrap: nowrap;
    gap: 1rem;
  }
}

@media (max-width: 1300px) {
  .footer-list {
    flex-wrap: nowrap;
    gap: 0.2rem;
  }
  
}



.footer-col {
  min-width: 120px;
}
@media (max-width: 1300px) {
  .footer-col{
    min-width: 100px;
  }
}
.footer-col dt {
  /* font-weight: 600; */
  margin-bottom: 2.5rem;
  color: #fff;
  font-size: 1.2rem;
}

.footer-col dd {
  margin: 1.2rem 0;
  color: #b2bdcd;
  cursor: pointer;
  font-size: 1.1rem;
  font-weight: 200;
}
.footer-phone {
  font-family: "HarmonyOS_Sans_SC";
  margin-top: 1rem;
  display: flex;
  /* flex-direction: column; */
  flex-wrap: nowrap;
  align-items: center;
  gap: 1rem;
  font-size: 1.5rem;
}
.footer-copyright {
  /* margin-top: 3rem; */
  font-size: 1rem;

  display: flex;
  justify-content: space-between;
}

/* 在 NewsView 页面中强制去掉 footer 上边距 */
.news-view-page .footer {
  margin-top: 0 !important;
}
</style>